import React, { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { IconButton, TextField } from '@material-ui/core';
import { MdClose as CloseIcon } from '@react-icons/all-files/md/MdClose';
import { createUseStyles } from '../../../../../../../../theming';
import clsx from 'clsx';
import { CreateTicketOptions } from '../../../../../../../../interfaces/api/Ticket';

interface Props {
  control: Control<CreateTicketOptions>;
  onClose: () => void;
  className?: string;
}

const useStyles = createUseStyles({
  root: {
    backgroundColor: '#f4f6f8',
    borderRadius: 5,
    padding: '5px 16px',
  },
  title: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#0000008a',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  formControl: {
    marginBottom: '16px !important',
  },
});

const ContactField: FC<Props> = ({ className, control, onClose }) => {
  const classes = useStyles();

  return (
    <div className={clsx(className, classes.root)}>
      <div className={classes.header}>
        <div className={classes.title}>Nouveau contact</div>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <Controller
        name='newContactFirstname'
        control={control}
        rules={{ required: { value: true, message: 'Le champ est requis' } }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            className={classes.formControl}
            label='Prénom'
            fullWidth
            required
            variant='outlined'
            error={undefined !== error}
            helperText={error?.message}
          />
        )}
      />

      <Controller
        name='newContactLastname'
        control={control}
        rules={{ required: { value: true, message: 'Le champ est requis' } }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            className={classes.formControl}
            label='Nom'
            fullWidth
            required
            variant='outlined'
            error={undefined !== error}
            helperText={error?.message}
          />
        )}
      />

      <Controller
        name='newContactPhoneNumber'
        control={control}
        rules={{ required: { value: true, message: 'Le champ est requis' } }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            className={classes.formControl}
            label='Téléphone'
            fullWidth
            required
            variant='outlined'
            error={undefined !== error}
            helperText={error?.message}
          />
        )}
      />

      <Controller
        name='newContactEmail'
        control={control}
        rules={{ required: { value: true, message: 'Le champ est requis' } }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            className={classes.formControl}
            label='Email'
            fullWidth
            required
            variant='outlined'
            error={undefined !== error}
            helperText={error?.message}
          />
        )}
      />
    </div>
  );
};

export default ContactField;
